import { render, staticRenderFns } from "./RoomTopicChanged.vue?vue&type=template&id=dee0ebb8&"
import script from "./RoomTopicChanged.vue?vue&type=script&lang=js&"
export * from "./RoomTopicChanged.vue?vue&type=script&lang=js&"
import style0 from "./RoomTopicChanged.vue?vue&type=style&index=0&id=dee0ebb8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports